import React,{ Component } from "react";
import { connect } from "react-redux";
import { updateConnectionProxy } from "../../../actions/actionConnectionProxies";
import { Row, Col,  Card, CardHeader, Container} from "reactstrap";
import ConnectionProxyForm from "../ConnectionProxyForm/ConnectionProxyForm";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "ConnectionProxy",path:"/connection_proxy",isActive: false},
    {name: "UpdateConnectionProxy",path:"/updateconnection_proxy",isActive: true},
];

class UpdateConnectionProxy extends Component{
    render(){
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>      
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Update Connection Proxy</strong>
                                </CardHeader>
                                <ConnectionProxyForm
                                    updateConnectionProxy={this.props.updateConnectionProxy}
                                    connectionProxyId={this.props.match.params.id}
                                    fromUpdate={true}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

UpdateConnectionProxy.propTypes = {
    updateConnectionProxy: Proptypes.func.isRequired,
    match: Proptypes.object
};

export default connect(state => ({
    connection_proxies: state.connection_proxies.connection_proxies || []
}), 
dispatch => ({
    updateConnectionProxy: (data) => dispatch(updateConnectionProxy(data))
}))(UpdateConnectionProxy);